export default __webpack_public_path__ + "static/media/e-merkator-talk-en.5677c55a.png";